module.exports = __webpack_public_path__ + "img/partner.ec871190.png";